const breakpoints = [
  '40em', //  640px - xsmall
  '52em', //  832px - small
  '64em', // 1024px - medium
  '88em', // 1408px - large
];

export default breakpoints;
